import mockb from '../../mockdata/vehicleMockB.json';
import mocke from '../../mockdata/vehicleMockE.json';

const mockModel = (formValues) => {
  const regnr = formValues.registrationNumber.toLowerCase();
  if (regnr === 'mockb') {
    return Promise.resolve(mockb);
  }
  if (regnr === 'mocke') {
    return Promise.resolve(mocke);
  }
  return Promise.reject();
};

export const isVechicleModelMock = (formValues) => {
  return formValues.registrationNumber.toLowerCase().includes('mock') && (
    window.location.href.includes('localhost')
    || ((window.location.href.includes('dev')
        || window.location.href.includes('sit')
        || window.location.href.includes('uat'))
      && window.location.href.includes('.tryg.dk')));
};

export const doVechicleModelMock = (formValues) => {
  return mockModel(formValues).then((response) => {
    return response;
  });
};
